export default (data) => {
  let timeZone = new Date().getTimezoneOffset();

  let tempDate = new Date(data);

  tempDate.setMinutes(timeZone);

  if (tempDate == 'Invalid Date' || !data) {
    return null;
  }
  return `${String(tempDate.getDate()).padStart(2, '0')}/${String(
    tempDate.getMonth() + 1
  ).padStart(2, '0')}/${tempDate.getFullYear()}`;
};

export const formatData = (data) => {
  let tempData = data?.split('T')[0].split('-');

  let day = tempData[2];
  let month = tempData[1];
  let year = tempData[0];

  return day.padStart(2, 0) + '/' + month.padStart(2, 0) + '/' + year;
};

export const formatDateYYYYMMDD = (date) => {
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  const year = date.getFullYear();

  const formatedDate = `${year}-${month}-${day}`;

  return formatedDate;
};

export const getDateYMD = () => {
  const date = new Date();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  const year = date.getFullYear();

  const dateYMD = `${year}${month}${day}`;

  return dateYMD;
};
